import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-poh-comp-add',
  templateUrl: './poh-comp-add.component.html',
  styleUrls: ['./poh-comp-add.component.css']
})
export class PohCompAddComponent implements OnInit {
    pohKeyno;

    stockKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.pohKeyno = this.stateService.getStateParams()['poh_keyno'];
        this.stockKeyno = this.stateService.getStateParams()['stock_keyno'];
    }

    private async loadEdit() {
        if (!!this.pohKeyno && !!this.stockKeyno) {
            this.edit = (await this.datatask.Post(158, {
                poh_keyno: this.pohKeyno,
                stock_keyno: this.stockKeyno
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(162, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    prod_id: string;
    prod_name: string;
    stock_keyno: string;
    batch_no: string;
    stockbatch_keyno: string;
    quantity_original: string;
    stock_stockvalue: string;
    status: string;
    quantity: string;
    poh_keyno: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('pohCompAdd', {
//        templateUrl: 'views/components/views/pohCompAdd/pohCompAdd.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'pohCompAddService', function ($stateParams, stateService, pohCompAddService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let pohKeyno = $stateParams.poh_keyno;
//            let stockKeyno = $stateParams.stock_keyno;

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await pohCompAddService.getEdit({
//                    poh_keyno: pohKeyno,
//                    stock_keyno: stockKeyno
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                pohCompAddService.saveObj(vm.model.edit).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
